import gql from 'graphql-tag';

// TODO protection
function tipsUri(hostName) {
  const env = hostName.split('-')[0];
  if (env === 'localhost') {
    return 'https://stg-tips.awair.is/unprotected-graphql';
  } else if (env === 'stg') {
    return 'https://stg-tips.awair.is/unprotected-graphql';
  } else {
    return 'https://tips.awair.is/unprotected-graphql';
  }
}

function queryFavoriteTip(sensor: String) {
  let query = `
  ${sensor}FavoriteTip: favoriteTip(deviceUuid: $deviceUuid, at: $at, language: $language, comp: ${sensor.toUpperCase()}) {
    __typename
    language
    backgroundColor
    fontColor
    title
    iconUrl
    body
    link
    imageLink
    abTest
  }
  `;
  return query;
}

function querySolutionTip(sensor: String, type: String) {
  // type is 0 or 1
  let query = `
  ${sensor}SolutionTip${type}: solutionTip(deviceUuid: $deviceUuid, at: $at, language: $language, comp: ${sensor.toUpperCase()}) {
    __typename
    component
    language
    iconUrl
    iconTitle
    iconTitleColor
    body
    fontColor
    abTest
  }
  `;
  return query;
}

function query(more: Boolean) {
  let typeAll = `
  __typename
  language
  fontColor
  backgroundColor
  body
  title
  iconUrl
  link
  imageLink
  component
  iconTitle
  iconTitleColor
  `;
  let type0 = `
  __typename
  language
  backgroundColor
  fontColor
  title
  iconUrl
  body
  link
  imageLink
  `;
  let queryannouncementForDeviceTypeTip = `
  announcementForDeviceTypeTip(deviceType: $deviceType, language: $language) {
    ${type0}
  }
  `;
  let queryAnnouncementForAllDeviceTypesTip = `
  announcementForAllDeviceTypesTip(language: $language) {
    ${type0}
  }
  `;
  let queryBlog = `
  blogTip(deviceUuid: $deviceUuid, language: $language) {
    ${type0}
    abTest
  }
  `;
  let queryMessageTip = `
  messageTip(deviceUuid: $deviceUuid, at: $at, language: $language) {
    __typename
    language
    backgroundColor
    fontColor
    body
    abTest
  }
  `;
  let queryProductTip = `
  productTip(deviceUuid: $deviceUuid, productCompany: BLUEAIR, language: $language) {
    __typename
    language
    iconUrl
    iconTitle
    title
    body
    link
    imageLink
  }
  `;
  let queryPartnerTip = `
  partnerTip(deviceUuid: $deviceUuid, partnerCompany: SAMSUNG, language: en) {
    __typename
    language
    iconUrl
    title
    fontColor
    body
    link
    imageLink
  }
  `;
  let queryDailyAverageTip = `
  dailyScoreComparison: dailyAverageTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    averageScoreToday
    averageScoreYesterday
    abTest
  }
  dailyTempComparison: dailyAverageTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    averageTempToday: averageCompToday(comp: TEMP)
    averageTempYesterday: averageCompYesterday(comp: TEMP)
    abTest
  }
  dailyHumidComparison: dailyAverageTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    averageHumidToday: averageCompToday(comp: HUMID)
    averageHumidYesterday: averageCompYesterday(comp: HUMID)
    abTest
  }
  dailyCo2Comparison: dailyAverageTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    averageCo2Today: averageCompToday(comp: CO2)
    averageCo2Yesterday: averageCompYesterday(comp: CO2)
    abTest
  }
  dailyVocComparison: dailyAverageTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    averageVocToday: averageCompToday(comp: VOC)
    averageVocYesterday: averageCompYesterday(comp: VOC)
    abTest
  }
  dailyDustComparison: dailyAverageTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    averageDustToday: averageCompToday(comp: DUST)
    averageDustYesterday: averageCompToday(comp: DUST)
    abTest
  }
  `;
  let queryNonePrediction = `
    ${queryannouncementForDeviceTypeTip}
    ${queryAnnouncementForAllDeviceTypesTip}
    ${queryBlog}
    ${queryFavoriteTip('humid')}
    ${queryFavoriteTip('voc')}
    ${queryFavoriteTip('pm25')}
    ${queryMessageTip}
    ${querySolutionTip('temp', '0')}
    ${querySolutionTip('temp', '1')}
    ${querySolutionTip('humid', '0')}
    ${querySolutionTip('humid', '1')}
    ${querySolutionTip('co2', '0')}
    ${querySolutionTip('co2', '1')}
    ${querySolutionTip('voc', '0')}
    ${querySolutionTip('voc', '1')}
    ${querySolutionTip('dust', '0')}
    ${querySolutionTip('dust', '1')}
    ${queryProductTip}
    ${queryPartnerTip}
    ${queryDailyAverageTip}
`;

  let queryPrediction = `
  tempPrediction: metricPredictionsTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    predictionsForTemp: metricPredictions(comp: TEMP) {
      time
      prediction
    }
    abTest
  }
  humidPrediction: metricPredictionsTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    predictionsForHumid: metricPredictions(comp: HUMID) {
      time
      prediction
    }
    abTest
  }
  co2Prediction: metricPredictionsTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    predictionsForCo2: metricPredictions(comp: CO2) {
      time
      prediction
    }
    abTest
  }
  vocPrediction: metricPredictionsTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    predictionsForVoc: metricPredictions(comp: VOC) {
      time
      prediction
    }
    abTest
  }
  dustPrediction: metricPredictionsTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    predictionsForDust: metricPredictions(comp: DUST) {
      time
      prediction
    }
    abTest
  }
  weeklySummaryTip(deviceUuid: $deviceUuid, at: $at) {
    __typename
    now
    secondsScoreWasGood
    secondsScoreWasFair
    secondsScoreWasPoor
    secondsScoreWasUnknown
    abTest
  }
  `;

  if (more) {
    return `
    ${queryannouncementForDeviceTypeTip}
    ${queryAnnouncementForAllDeviceTypesTip}
    ${queryBlog}
    ${queryMessageTip}
    ${querySolutionTip('temp', '0')}
    ${querySolutionTip('temp', '1')}
    ${querySolutionTip('humid', '0')}
    ${querySolutionTip('humid', '1')}
    ${querySolutionTip('co2', '0')}
    ${querySolutionTip('co2', '1')}
    ${querySolutionTip('voc', '0')}
    ${querySolutionTip('voc', '1')}
    ${querySolutionTip('dust', '0')}
    ${querySolutionTip('dust', '1')}
    ${queryProductTip}
    ${queryPartnerTip}
  `;
  } else {
    const env = window.location.hostname.split('-')[0];
    if (env === 'localhost') {
      return queryNonePrediction;
    } else if (env === 'stg') {
      return queryNonePrediction;
    } else {
      return queryNonePrediction + queryPrediction;
    }
  }
}
let Service = {};
Service.credentials = 'same-origin';
Service.insights = {};
Service.insights.uri = tipsUri(window.location.hostname);
Service.insights.queries = {};
Service.insights.queries.insights = {};
Service.insights.queries.insights.all = gql`
  query Tips($deviceType: String!, $deviceUuid: String!, $at: DateTime!, $language: Language!) {
    ${query()}
  }
`;
Service.insights.queries.insights.legacy = gql`
  query Tips($deviceType: String!, $deviceUuid: String!, $at: DateTime!, $language: Language!) {
    ${query(true)}
  }
`;

export default Service;
